<script setup>
import { computed } from 'vue'
import AccordionItem from './AccordionItem.vue'

const props = defineProps({
  block: { type: Object, required: true },   // { heading, subheading, items: [{title, body, open}] }
})

const items = computed(() => props.block.items || [])

// Deterministic panel ids (no Math.random → stable across SSG prerender +
// client hydration). Slug of the title, disambiguated by index.
const slug = (s) =>
  (s || 'item').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')
const panelId = (item, i) => `acc-${slug(props.block.heading)}-${slug(item.title)}-${i}`
</script>

<template>
  <div class="accordion-block">
    <div v-if="block.heading || block.subheading" class="headers">
      <h2 v-if="block.heading" class="heading">{{ block.heading }}</h2>
      <p v-if="block.subheading" class="subheading">{{ block.subheading }}</p>
    </div>

    <div class="items">
      <AccordionItem
        v-for="(item, i) in items"
        :key="i"
        :item="item"
        :panel-id="panelId(item, i)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.accordion-block {
  display: flex;
  flex-direction: column;
  gap: $space-5;

  .headers {
    display: flex;
    flex-direction: column;
    gap: $space-2;

    .heading {
      margin: 0;
      font-size: $font-size-h2;
      font-weight: 500;
      line-height: $lh-heading;
      letter-spacing: $ls-heading;
      color: var(--color-ink);
    }
    .subheading {
      margin: 0;
      font-size: $font-size-lg;
      color: var(--color-text-muted);
    }
  }

  .items {
    display: flex;
    flex-direction: column;
    gap: $space-3;
  }
}
</style>
